import React from "react";
import "./styles.css";

export interface LinkTextProps {
  children: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
}

const LinkText: React.FC<LinkTextProps> = ({ children, disabled = false, onClick, className = "" }) => {
  return (
    <p className={`link-text ${className}`} onClick={disabled ? undefined : onClick}>
      {children}
    </p>
  );
};

export default LinkText;
